import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { cssClassPrefix } from '../../shared/constants/generalConstants.js';
import { IlButton } from '../IlButton/index.js';
import img from '../../assets/illustrations/empty.svg.js';
import img$5 from '../../assets/illustrations/error.svg.js';
import img$6 from '../../assets/illustrations/maintenance.svg.js';
import img$d from '../../assets/illustrations/no-results.svg.js';
import img$8 from '../../assets/illustrations/welcome.svg.js';
import img$c from '../../assets/illustrations/no-access.svg.js';
import img$3 from '../../assets/illustrations/document.svg.js';
import img$2 from '../../assets/illustrations/contract.svg.js';
import img$h from '../../assets/illustrations/welcome-rocket.svg.js';
import img$f from '../../assets/illustrations/search-results.svg.js';
import img$g from '../../assets/illustrations/user-search.svg.js';
import img$e from '../../assets/illustrations/no-user.svg.js';
import img$4 from '../../assets/illustrations/download.svg.js';
import img$a from '../../assets/illustrations/avatar-network.svg.js';
import img$1 from '../../assets/illustrations/blueprint.svg.js';
import img$b from '../../assets/illustrations/document-box.svg.js';
import img$7 from '../../assets/illustrations/people.svg.js';
import img$9 from '../../assets/illustrations/workspace.svg.js';
import img$j from '../../assets/illustrations/drag-and-drop.svg.js';
import img$i from '../../assets/illustrations/analyze-files.svg.js';

var BASE_CLASS = "".concat(cssClassPrefix, "-states");
var IlStates = function IlStates(props) {
  var className = props.className,
    title = props.title,
    illustration = props.illustration,
    customIllustration = props.customIllustration,
    description = props.description,
    button = props.button,
    _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'horizontal' : _props$layout,
    renderContent = props.renderContent,
    disclaimer = props.disclaimer,
    shouldCenterAlignContent = props.shouldCenterAlignContent;
  var _ref = button || {},
    text = _ref.text,
    kind = _ref.kind,
    size = _ref.size,
    onClick = _ref.onClick;
  var renderIllustration = function renderIllustration() {
    if ('customIllustration' in props) {
      return customIllustration;
    }
    var illustrationsMap = {
      blueprint: img$1,
      contract: img$2,
      document: img$3,
      download: img$4,
      empty: img,
      error: img$5,
      maintenance: img$6,
      people: img$7,
      welcome: img$8,
      workspace: img$9,
      'avatar-network': img$a,
      'document-box': img$b,
      'no-access': img$c,
      'no-results': img$d,
      'no-user': img$e,
      'search-results': img$f,
      'user-search': img$g,
      'welcome-rocket': img$h,
      'analyze-files': img$i,
      'drag-and-drop': img$j
    };
    return illustrationsMap[illustration] || img;
  };
  var shouldRenderIllustration = function shouldRenderIllustration() {
    return 'illustration' in props || 'customIllustration' in props;
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: classNames(BASE_CLASS, "".concat(BASE_CLASS, "-").concat(layout), className, _defineProperty({}, "".concat(BASE_CLASS, "-centered"), shouldCenterAlignContent))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(BASE_CLASS, "-content")
  }, layout === 'horizontal' ? /*#__PURE__*/React__default.createElement("h1", {
    className: "".concat(BASE_CLASS, "-title")
  }, title) : /*#__PURE__*/React__default.createElement("h2", {
    className: "".concat(BASE_CLASS, "-title")
  }, title), description && /*#__PURE__*/React__default.createElement("p", {
    className: "".concat(BASE_CLASS, "-description")
  }, description), renderContent && /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(BASE_CLASS, "-custom-content")
  }, renderContent()), button && /*#__PURE__*/React__default.createElement(IlButton, {
    kind: kind,
    size: size,
    onClick: onClick
  }, text), disclaimer && /*#__PURE__*/React__default.createElement("div", {
    className: classNames(_defineProperty(_defineProperty({}, "".concat(BASE_CLASS, "-disclaimer-custom-content"), renderContent), "".concat(BASE_CLASS, "-disclaimer"), !renderContent))
  }, disclaimer)), shouldRenderIllustration() && /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(BASE_CLASS, "-illustration")
  }, /*#__PURE__*/React__default.createElement("img", {
    src: renderIllustration(),
    alt: title
  })));
};
IlStates.propTypes = {
  title: PropTypes.string.isRequired,
  illustration: PropTypes.oneOf(['empty', 'error', 'maintenance', 'no-results', 'welcome', 'no-access', 'document', 'contract', 'search-results', 'welcome-rocket', 'user-search', 'no-user', 'download', 'avatar-network', 'blueprint', 'document-box', 'people', 'workspace', 'analyze-files', 'drag-and-drop']),
  customIllustration: PropTypes.string,
  layout: PropTypes.oneOf(['horizontal', 'vertical']),
  description: PropTypes.string,
  renderContent: PropTypes.func,
  disclaimer: PropTypes.node,
  button: PropTypes.shape({
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    kind: IlButton.propTypes.kind,
    size: IlButton.propTypes.size
  }),
  className: PropTypes.string,
  shouldCenterAlignContent: PropTypes.bool
};

export { IlStates };
